export enum RouteNames {
  Home = '/home',
  Login = '/',
  Logout = '/logout',
  Surveys = 'surveys',
  PasswordReset = '/password-reset',
  PasswordResetConfirm = '/password-reset/confirm',
  Page404 = '/404',
  CreateSurvey = '/create-survey',
  Participants = '/participants',
  Reports = '/reports',
  Results = '/results',
  SessionExpired = '/session-expired',
}

export interface Routes {
  [RouteNames.Home]: string;
  [RouteNames.Surveys]: string;
  [RouteNames.Login]: string;
  [RouteNames.PasswordReset]: string;
  [RouteNames.PasswordResetConfirm]: string;
  [RouteNames.Page404]: string;
  [RouteNames.CreateSurvey]: string;
  [RouteNames.Participants]: string;
  [RouteNames.SessionExpired]: string;
}

export enum RoleNames {
  EBHRStaff = 'EBHR Staff',
  EBHRConsultant = 'EBHR Consultant',
  SurveyAdministrator = 'Survey Administrator',
  Manager = 'Manager',
  SurveyConsultant = 'Survey Consultant',
}

export interface Roles {
  [RoleNames.EBHRStaff]: string;
  [RoleNames.EBHRConsultant]: string;
  [RoleNames.SurveyAdministrator]: string;
  [RoleNames.Manager]: string;
  [RoleNames.SurveyConsultant]: string;
}

export const routesAccessRights = {
  [RouteNames.Surveys]: [
    RoleNames.EBHRConsultant,
    RoleNames.SurveyAdministrator,
    RoleNames.SurveyConsultant,
  ],
  [RouteNames.Reports]: [
    RoleNames.EBHRConsultant,
    RoleNames.SurveyAdministrator,
    RoleNames.Manager,
    RoleNames.SurveyConsultant,
  ],
};

export const EBHRMembers = [RoleNames.EBHRConsultant, RoleNames.EBHRStaff];

export const redirectBaskets = {
  highPriority: {
    roles: [RoleNames.EBHRConsultant, RoleNames.SurveyAdministrator, RoleNames.SurveyConsultant],
    routeName: '/surveys',
  },
  mediumPriority: {
    roles: [RoleNames.Manager],
    routeName: '/reports',
  },
};
